import { render, staticRenderFns } from "./ChangeWarrantyProductV2.vue?vue&type=template&id=28d0fa42&scoped=true"
import script from "./ChangeWarrantyProductV2.vue?vue&type=script&lang=js"
export * from "./ChangeWarrantyProductV2.vue?vue&type=script&lang=js"
import style0 from "./ChangeWarrantyProductV2.vue?vue&type=style&index=0&id=28d0fa42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d0fa42",
  null
  
)

export default component.exports